import { mergeStyleSets } from '@fluentui/react';
import styled from 'styled-components';

export const modalStyles = mergeStyleSets({
  container: {
    display: 'flex',
    borderRadius: 16,
    width: 1000,
    padding: '32px 16px',
    boxShadow: 'inset 0 6px 0 0 #FD6262, 1px 1px 8px rgba(0, 0, 0, 0.05)',
  },
});

export const AppModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AppModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px;
  align-items: center;

  button.closeModal {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    background: none;
    color: ${({ theme }: {theme: any}) => theme.black};
    cursor: pointer;

    &:hover {
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0.5rem;

    h2 {
      display: none;
    }
  }
`;

export const AppModalDescription = styled.div`
  padding-left: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  --swiper-theme-color: ${({ theme }: {theme: any}) => theme.themePrimary};

  .carouselItemImage {
    margin: 0px 0px 5px 5px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > div {
    max-width: 290px;
    max-height: 180px;
    border-radius: 1rem;
    overflow: hidden;
  }

  p {
    font: 400 0.9rem/1.3rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    text-align: justify;
    flex: 1;
  }
`;

export const AppLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;

  button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 10px 1.2rem;
    border-radius: 6px;
    border: none;
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;

    font: 500 1rem/1rem 'Roboto', sans-serif;
    cursor: pointer;

    transition: all 0.2s ease;

    &:hover {
      background: ${({ theme }: {theme: any}) => theme.themeTertiary};
    }
  }
`;

export const AppModalSubscription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px;

  span {
    font: 400 1rem/1.1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const AppPlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const AppPlanCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  padding-right: 100px;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  border-radius: 10px;
  box-shadow: inset 4px 0 0 0 ${({ theme }: {theme: any}) => theme.themePrimary},
    1px 1px 8px rgba(0, 0, 0, 0.05);
  gap: 6px;
  overflow: hidden;
  cursor: pointer;

  h1 {
    font: 700 1rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  p {
    font: 300 0.75rem/0.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;
    border: none;
    position: absolute;
    border-radius: 10px;
    padding: 1rem;
    top: 0;
    bottom: 0;
    right: -100%;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }

  &:hover button {
    right: 0;
  }
`;

export const AppModalDemo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  p {
    font: 400 1rem/1.1rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
    padding: 0 20px;
  }

  .videoContainer {
    width: 60%;
    margin: 0 auto;

    .iframeWrapper {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%;
      overflow: hidden;
      border-radius: 1rem;

      .thumbnail {
        display: flex;
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
      }

      iframe {
        display: none;
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &.loaded {
        iframe {
          display: flex;
        }
        .thumbnail {
          display: none;
        }
      }
    }
  }
`;
